import UIButton from 'UIComponents/button/UIButton';
import UILink from 'UIComponents/link/UILink';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { MarketingCtaWrapper } from './MarketingCta.styles';
import { getSignupUrl } from '../../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MarketingCta = ({
  allowFbSignup,
  signupParams,
  loginRedirectUrl,
  pageId
}) => {
  const signupUrl = getSignupUrl(signupParams, allowFbSignup, pageId, loginRedirectUrl);
  return /*#__PURE__*/_jsxs(MarketingCtaWrapper, {
    children: [/*#__PURE__*/_jsx(UILink, {
      href: signupUrl,
      children: /*#__PURE__*/_jsx(UIButton, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "login.marketingCopy.getStarted"
        })
      })
    }), /*#__PURE__*/_jsx(UILink, {
      href: "https://offers.hubspot.com/crm-platform-demo?hubs_signup-url=https://app.hubspot.com/login/&hubs_signup-cta=gad",
      children: /*#__PURE__*/_jsx(UIButton, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "login.marketingCopy.getDemo"
        })
      })
    })]
  });
};
export default MarketingCta;